export namespace AvatarConsts {
  export const fallbackUserName = 'Anonymous';
  export const defaultAvatarSize = '25px';
}
